import { render, staticRenderFns } from "./Batches.vue?vue&type=template&id=eb7c2e3a&scoped=true&"
import script from "./Batches.vue?vue&type=script&lang=js&"
export * from "./Batches.vue?vue&type=script&lang=js&"
import style0 from "./Batches.vue?vue&type=style&index=0&id=eb7c2e3a&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7c2e3a",
  null
  
)

export default component.exports